export enum AccountType {
  MULTIPLE = <any>'MULTIPLE',
  SINGLE = <any>'SINGLE'
}
